import title from "global/constants/TitleConstants";
import { useLocation } from "react-router-dom";
import { useTitle } from "utils/UseTitle";
import Step2 from "./components/Step2";
import Step1 from "./components/Step1";
import { useEffect, useState } from "react";
import { CampaignContext } from "../Context";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { Container } from "@mui/material";
import { SubmitCampaign } from "types/Campaign";
import { initialSubmitCampaignFields } from "../Constants";

const SequentialCampaign = () => {
  useTitle(title.CREATE_SEQUENTIAL_CAMPAIGN);
  const urlParams = new URLSearchParams(useLocation().search);
  const campaignId = urlParams.get("id");
  const [submitCampaign, setSubmitCampaign] = useState<SubmitCampaign>(
    initialSubmitCampaignFields("Regular") as SubmitCampaign
  );
  const [activeStep, setActiveStep] = useState<number>(0);
  const [managingStep, setManagingStep] = useState<string>("");
  const [childCampaigns, setChildCampaigns] = useState<SubmitCampaign[]>([]);

  useEffect(() => {
    if (campaignId) {
      retrieveCampaignDetails();
    } else {
      initChildCampaigns();
    }
  }, [campaignId]);

  const initChildCampaigns = () => {
    const campaigns = ["Untitled Campaign 1", "Untitled Campaign 2"].map(
      (name, index: number) => {
        const childCampaign = initialSubmitCampaignFields(
          "Regular"
        ) as SubmitCampaign;
        childCampaign.campaign.id = new Date().getTime() + index;
        childCampaign.campaign.name = name;
        return childCampaign;
      }
    );
    setChildCampaigns(campaigns);
  };

  const retrieveCampaignDetails = async () => {
    try {
      // setActiveStep(true);
    } catch (error: any) {}
  };

  const getSteps = () => {
    if (!childCampaigns.length) {
      return null;
    }
    if (activeStep === 1) {
      return (
        <Step2
          setActiveStep={setActiveStep}
          childCampaigns={childCampaigns}
          setChildCampaigns={setChildCampaigns}
        />
      );
    } else {
      return (
        <Step1
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          childCampaigns={childCampaigns}
          setChildCampaigns={setChildCampaigns}
        />
      );
    }
  };

  const saveAsDraft = () => {};

  return (
    <CampaignContext.Provider
      value={{
        submitCampaign,
        setSubmitCampaign,
        managingStep,
        setManagingStep,
        saveAsDraft,
      }}
    >
      <CenteredAuthenticatedLayout>
        <Container maxWidth="md">{getSteps()}</Container>
      </CenteredAuthenticatedLayout>
    </CampaignContext.Provider>
  );
};

export default SequentialCampaign;
